import React, { useState, useEffect } from 'react';
import { wsGetAll } from 'services/WService';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from 'components/Tvendo/Common/ModalBase';

export default function ModalCategory(props) {
  const category = props.model;

  const [dataChanging, setDataChanging] = useState(category);
  const [businessPartners, setBusinessPartners] = useState([]);

  async function listBusinessPartners() {
    let response = await wsGetAll('base/business-partner?CardType=S&QryGroup1=Y');
    if (response.success) setBusinessPartners(response.data);
  }

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  useEffect(() => {
    if (category.open) {
      listBusinessPartners();
    }
  }, [category.open]);

  return (
    <Modal
      title="Categoría"
      model={category}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="logi/category"
      state
    >
      <TextField
        label="Código"
        fullWidth
        type="text"
        name="code"
        margin="normal"
        defaultValue={category.code || ''}
        required
      />
      <TextField
        label="Descripción"
        fullWidth
        type="text"
        name="description"
        margin="normal"
        defaultValue={category.description || ''}
        required
      />
      {businessPartners.length > 0 ? (
        <Autocomplete
          disableClearable
          options={businessPartners}
          getOptionLabel={(option) => option.CardName}
          defaultValue={
            !!category
              ? businessPartners.find(
                  (businessP) => businessP.id == category.base_business_partner_id
                )
              : undefined
          }
          renderInput={(params) => (
            <TextField {...params} label="Socio de Negocio" margin="normal" required />
          )}
          onChange={(e, item) => {
            if (!!item) {
              return handleChange('base_business_partner_id', item.id);
            }
            handleChange('base_business_partner_id', null);
          }}
        />
      ) : undefined}
    </Modal>
  );
}
